// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../../../styles/helpers.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__formItemHalf___kl56G {
}

.styles__fieldWrapper___g5pl7 {
  display: inline-block;
  margin-right: 20px;
  vertical-align: top;
}
`, "",{"version":3,"sources":["webpack://./universal/routes/Protected/Closings/components/Edit/ClosingFeeForm/styles.css"],"names":[],"mappings":"AAEA;AAEA;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,mBAAmB;AACrB","sourcesContent":["@value helpers: \"styles/helpers.css\";\n\n.formItemHalf {\n  composes: formItemHalf from helpers;\n}\n\n.fieldWrapper {\n  display: inline-block;\n  margin-right: 20px;\n  vertical-align: top;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"helpers": `"styles/helpers.css"`,
	"formItemHalf": `styles__formItemHalf___kl56G ${___CSS_LOADER_ICSS_IMPORT_0___.locals["formItemHalf"]}`,
	"fieldWrapper": `styles__fieldWrapper___g5pl7`
};
export default ___CSS_LOADER_EXPORT___;
